export default "Audit TURPE consolidé de votre parc : puissances souscrites par classe temporelle, version tarifaire, dépassements, énergie réactive. Économies récurrentes sans changer de fournisseur.";
